/** Resolve the Turn-Table Touch angular hit window with the accessibility beat-window assist.
 *  Widen-only: the assist multiplies the half-width but never changes the combo ramp.
 *  The full window (2*halfWidthRad) is clamped < PI so it cannot wrap past the ring top. */
export const TTT_MAX_HALF_WIDTH_RAD = Math.PI / 2 - 0.05; // full window stays < PI

export function resolveTttWindow(
  baseHalfRad: number,
  baseComboMult: number,
  beatWindowMultiplier: number,
): { halfWidthRad: number; comboSpeedMultiplier: number } {
  const widened = baseHalfRad * (beatWindowMultiplier > 0 ? beatWindowMultiplier : 1);
  return {
    halfWidthRad: Math.min(widened, TTT_MAX_HALF_WIDTH_RAD),
    comboSpeedMultiplier: baseComboMult, // widen-only; no combo damp
  };
}
